import { useCallback } from 'react';
import { FormikProps } from 'formik';

type UseSingleFileDropOptions = {
  fieldName: string;
  maxSizeMB?: number;
  singleFileError?: string;
  sizeError?: string;
};

export const useSingleFileDrop = (
  formik: FormikProps<any>,
  {
    fieldName,
    maxSizeMB = 5,
    singleFileError = 'You can only upload one file.',
    sizeError = `File size is too large. Maximum size is ${maxSizeMB}MB.`,
  }: UseSingleFileDropOptions
) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.[fieldName] || null;

      const filtered = acceptedFiles.find(
        (file) => file.size <= maxSizeMB * 1024 * 1024
      );

      // Size error
      if (!filtered) {
        formik.setFieldError(fieldName, sizeError);
        formik.setFieldTouched(fieldName, true, false);
        return;
      }

      // Only one file allowed
      if (filtered && currentFile !== null) {
        formik.setFieldError(fieldName, singleFileError);
        formik.setFieldTouched(fieldName, true, false);
        return;
      }

      // Valid file
      formik.setFieldValue(fieldName, filtered);
      formik.setFieldError(fieldName, '');
    },
    [formik, fieldName, maxSizeMB, sizeError, singleFileError]
  );

  return onDrop;
};
